import { Icon } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { indexSocial } from "services/post/PartnershipService";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import { Link, useNavigate } from "react-router-dom";
import NoContent from "components/cards/NoContent";
import placeholder from "images/placeholder-small.png";
import Pagination from "components/table/Pagination";

const RadarSocialGeral: React.FC = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [institutional, setInstitutional] =
    useState<InstitutionalResponse | null>(null);

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const navigate = useNavigate();
  const [banner, setBanner] = useState("");
  const [paginationData, setPaginationData] = useState<any>();

  const fetchInstitutional = async () => {
    try {
      const data = await getInstitutional(10);
      setInstitutional(data);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const filters = {
        page: page,
        per_page: 8,
      };

      const response = await indexSocial(filters);
      setData(response.data);

      setPaginationData({
        current_page: response.current_page,
        last_page: response.last_page,
        per_page: response.per_page,
        total: response.total,
      });

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    if (institutional) {
      setBanner(
        `${urlBase}/storage/images/institutional/banners/${
          institutional?.banners?.find((e) => e.name == "Banner radar social")
            ?.banner_path
        }`
      );
    }
  }, [institutional]);

  useEffect(() => {
    fetchInstitutional();
    fetchData();
  }, []);

  const handlePaginationChange = async (page: number) => {
    await fetchData(page);
  };

  return (
    <div className="flex flex-col items-center mt-5 p-1">
      <div
        className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
          {institutional?.texts?.find((e) => e.name == "Titulo do banner")
            ?.text ?? ""}
        </span>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt; <Link to={"/social"}>Radar-Social</Link>
      </span>
      <section>
        <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] mt-8 mb-20">
          <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">
            <div
              className="w-full"
              dangerouslySetInnerHTML={{
                __html:
                  institutional?.texts?.find(
                    (e) => e.name == "Descrição de introdução"
                  )?.text ?? "",
              }}
            ></div>

            <iframe
              className="shadow-2xl w-[17rem] sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
              width="1980"
              height="1024"
              src={
                institutional?.videos?.find(
                  (e) => e.name == "Video Radar Social"
                )?.video_path ?? ""
              }
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      </section>
      <section>
        {/* <div className="flex flex-col mb-10 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
          <Link to={'/'}>Home</Link> &gt; <Link to={'/social'}>Radar-Social</Link>
        </div> */}

        {/* <div className="flex flex-col mb-10 px-4 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
          <button className="flex justify-between items-center rounded-full dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 py-4 gap-x-2 pl-8 pr-6 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
            Nacional
            <Icon component={KeyboardArrowDownOutlinedIcon} fontSize="small" />
          </button>
        </div> */}

        {/* cards */}
        <div
          className="flex flex-col mb-10 px-4 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {/* top cards */}

          {data ? (
            data.map((item: any) => {
              return (
                <>
                  <div
                    className="flex flex-col flex-wrap m-2"
                    style={{ width: "17rem" }}
                  >
                    <div className="grid">
                      <div
                        className="h-96 max-w-sm rounded-3xl overflow-hidden shadow-lg bg-white dark:bg-gray-600 cursor-pointer hover:bg-primary-50 hover:dark:bg-gray-400"
                        key={item.id}
                        onClick={() => navigate(`/social-parceiros/${item.id}`)}
                      >
                        <img
                          // add class to image cover
                          className="w-full object-cover"
                          style={{ height: "70%" }}
                          src={
                            urlBase +
                            "/storage/images/posts/partnerships/logos/" +
                            item.logo_path
                          }
                          onError={(e) => (e.currentTarget.src = placeholder)}
                          alt={item.name}
                        ></img>
                        <div className="flex justify-center pt-3">
                          <span className="font-semibold text-sm text-primary-400 my-2">
                            {item.category.name}
                          </span>
                        </div>
                        <div className="flex justify-center px-6 py-1">
                          <span className="font-semibold text-xl mb-2" style={{fontSize: '17px'}}>
                            {item.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <>
              <NoContent />
            </>
          )}

        </div>

        {
          data.length > 0 && (
            <div className="my-5 flex justify-start">
              <Pagination pagination={paginationData} fetchData={(page: number) => handlePaginationChange(page)} />
            </div>
          )
        }

      </section>
    </div>
  );
};

export default RadarSocialGeral;
